import { Stack, Typography } from '@mui/material'
import React from 'react'

interface AddressBlockProps {
  street: string | undefined
  city: string | undefined
  country: string | undefined
}

const AddressBlock: React.FC<AddressBlockProps> = ({ street, city, country }) => {
  if (!street && !city && !country) return null

  return (
    <Stack>
      {street && <Typography variant="body2">{street}</Typography>}
      {city && <Typography variant="body2">{city}</Typography>}
      {country && <Typography variant="body2">{country}</Typography>}
    </Stack>
  )
}

export default AddressBlock
